<template>
  <div class="modal-card" style="width: 600px; max-width: 100%">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ lang('Theo dõi bản mới trong thư mục') }}</p>
    </header>

    <section class="modal-card-body">
      <ChoXuLy :dang="dangTai" :uoc-tinh="30" :nhan="lang('Đang quét thư mục và tra cứu bản mới cho từng tệp...')" />
      <ChoXuLy :dang="dangLuu" :uoc-tinh="20" :nhan="lang('Đang kiểm tra nguồn và lưu các mục đã chọn...')" />
      <p class="qt-duong">{{ thuMuc }}</p>
      <div v-if="loi" class="notification is-danger is-light">{{ loi }}</div>

      <p v-if="!dangTai && !ds.length && !loi" class="qt-rong">{{ lang('Thư mục này không có tệp .exe nào.') }}</p>

      <div v-if="daLuu" class="qt-ketqua">
        <div class="notification is-success is-light">
          {{ lang('Đã bắt đầu theo dõi') }} <b>{{ ketQua.filter(k => k.ok).length }}</b> {{ lang('phần mềm') }}.
        </div>
        <div v-if="ketQua.some(k => !k.ok)" class="notification is-danger is-light">
          <b>{{ ketQua.filter(k => !k.ok).length }}</b> {{ lang('mục không theo dõi được') }}:
          <ul>
            <li v-for="k in ketQua.filter(k => !k.ok)" :key="k.ten"><b>{{ k.ten }}</b> — {{ k.loi }}</li>
          </ul>
        </div>
      </div>

      <template v-if="!daLuu">
        <div v-for="x in ds" :key="x.duong_dan" class="qt-dong">
          <b-checkbox v-if="chonDuoc(x)" v-model="chon[x.duong_dan]">
            <span class="qt-ten">{{ x.ten }}</span>
            <span class="qt-phu">
              {{ x.ung_dung }} {{ x.phien_ban }} ({{ x.may }}) · {{ x.ma_goi }}
              <b-tag v-if="coBanMoi(x)" type="is-info">{{ lang('Có bản mới') }} {{ x.moi_nhat }}</b-tag>
              <b-tag v-else-if="x.moi_nhat">{{ lang('Đang là mới nhất') }}</b-tag>
            </span>
            <span v-if="x.ban_cu" class="qt-phu qt-luuy">{{ lang('Cùng phần mềm với tệp mới hơn trong thư mục nên không chọn sẵn (tích nếu vẫn muốn theo dõi riêng)') }}</span>
          </b-checkbox>
          <div v-else class="qt-khong">
            <span class="qt-ten">{{ x.ten }}</span>
            <b-tag v-if="x.dang_theo_doi" type="is-success">{{ lang('Đang theo dõi') }}</b-tag>
            <b-tag v-else-if="x.khong_nhan_dien">{{ lang('Không đọc được thông tin') }}</b-tag>
            <span v-else-if="x.ly_do" class="qt-ly-do">{{ x.ly_do }}</span>
            <b-tag v-else type="is-warning">{{ lang('Chưa tìm được nguồn, hãy theo dõi riêng từng tệp') }}</b-tag>
          </div>
        </div>
      </template>

      <template v-if="!daLuu && (soChon > 0 || ds.length)">
        <b-field :label="lang('Khi có bản mới')" class="qt-cachtai">
          <b-radio v-model="cheDo" native-value="tay">{{ lang('Chỉ thông báo, tôi tự bấm tải') }}</b-radio>
          <b-radio v-model="cheDo" native-value="tu_dong">{{ lang('Tự động tải khi có bản mới') }}</b-radio>
        </b-field>
        <p v-if="cheDo === 'tu_dong'" class="help">{{ lang('Hệ thống kiểm tra bản mới theo lịch mỗi ngày (khoảng 02:30), thấy có bản mới là tự tải và thay, duy trì về sau.') }}</p>
        <b-checkbox v-model="taiNgay">{{ lang('Tải ngay khi bấm Lưu (với các phần mềm đã có bản mới)') }}</b-checkbox>
        <b-checkbox v-model="giuCu">{{ lang('Giữ bản cũ') }}</b-checkbox>
        <p class="help" :class="{ 'qt-canh-bao': !giuCu }">{{ ghiChu }}</p>
      </template>
    </section>

    <footer class="modal-card-foot">
      <button v-if="daLuu" class="button is-primary" @click="$parent.close()">{{ lang('Đóng') }}</button>
      <template v-else>
        <button class="button" @click="$parent.close()">{{ lang('Cancel') }}</button>
        <button class="button is-primary" :class="{ 'is-loading': dangLuu }" :disabled="soChon === 0 || dangTai || dangLuu" @click="luu">
          {{ lang('Lưu theo dõi') }} ({{ soChon }})
        </button>
      </template>
    </footer>
  </div>
</template>

<script>
import api from '../../api/api'
import ChoXuLy from './ChoXuLy'

export default {
  name: 'QuetThuMucDialog',
  components: { ChoXuLy },
  props: {
    thuMuc: { type: String, default: '/' },
  },
  data() {
    return {
      dangTai: true,
      dangLuu: false,
      ds: [],
      chon: {},
      cheDo: 'tay',
      giuCu: true,
      taiNgay: false,
      daLuu: false,
      ketQua: [],
      loi: '',
    }
  },
  computed: {
    soChon() {
      return this.ds.filter(x => this.chon[x.duong_dan]).length
    },
    ghiChu() {
      return this.giuCu
        ? this.lang('Bản cũ được giữ nguyên bên cạnh bản mới.')
        : this.lang('Bản cũ sẽ được chuyển vào thùng rác (giữ 7 ngày, khôi phục được).')
    },
  },
  mounted() {
    api.capNhatQuet({ path: this.thuMuc })
      .then(ds => {
        this.ds = ds
        const chon = {}
        ds.forEach(x => { chon[x.duong_dan] = this.chonDuoc(x) && !!x.chon_san })
        this.chon = chon
        this.dangTai = false
      })
      .catch(error => {
        const d = error && error.response && error.response.data && error.response.data.data
        this.loi = typeof d === 'string' ? d : this.lang('Unknown error')
        this.dangTai = false
      })
  },
  methods: {
    chonDuoc(x) {
      // Chi cho tich khi nguon da duoc kiem tra la thay duoc tep nay
      return !x.dang_theo_doi && !x.khong_nhan_dien && !!x.ma_goi && !!x.phu_hop
    },
    coBanMoi(x) {
      return !!x.moi_nhat && this.soSanh(x.moi_nhat, x.phien_ban) > 0
    },
    soSanh(a, b) {
      const x = String(a).match(/\d+/g) || []
      const y = String(b).match(/\d+/g) || []
      for (let i = 0; i < Math.max(x.length, y.length); i++) {
        const p = parseInt(x[i] || 0, 10)
        const r = parseInt(y[i] || 0, 10)
        if (p !== r) return p > r ? 1 : -1
      }
      return 0
    },
    luu() {
      const cacMuc = this.ds.filter(x => this.chon[x.duong_dan])
      this.dangLuu = true
      const ketQua = []
      // Lan luot tung muc (khong song song) de khong vuot han muc tra cuu cua GitHub
      cacMuc.reduce((p, x) => p.then(() => api.capNhatThem({
        path: x.duong_dan, ma_goi: x.ma_goi, che_do: this.cheDo, giu_cu: this.giuCu, tai_ngay: this.taiNgay,
      }).then(() => { ketQua.push({ ten: x.ten, ok: true }) }).catch(error => {
        const d = error && error.response && error.response.data && error.response.data.data
        ketQua.push({ ten: x.ten, ok: false, loi: typeof d === 'string' ? d : this.lang('Lỗi không xác định') })
      })), Promise.resolve())
        .then(() => {
          this.dangLuu = false
          this.$emit('saved')
          if (ketQua.every(k => k.ok)) {
            this.$toast.open({
              message: this.lang('Đã bắt đầu theo dõi') + ' ' + ketQua.length + ' ' + this.lang('phần mềm') + (this.taiNgay ? ', ' + this.lang('đang tải bản mới ở nền') : ''),
              type: 'is-success',
            })
            this.$parent.close()
            return
          }
          // Co muc that bai: giu hop thoai de hien ro ly do tung muc (truoc day chi bao "N loi")
          this.ketQua = ketQua
          this.daLuu = true
        })
    },
  },
}
</script>

<style scoped>
.qt-duong { font-size: 0.85rem; color: #7d8a9a; margin-bottom: 0.8rem; word-break: break-all; }
.qt-rong { color: #7d8a9a; }
.qt-dong { padding: 0.45rem 0; border-bottom: 1px solid rgba(127, 140, 160, 0.2); }
.qt-ten { display: block; word-break: break-all; }
.qt-phu { display: block; font-size: 0.8rem; opacity: 0.75; }
.qt-khong { display: flex; align-items: center; justify-content: space-between; gap: 0.6rem; opacity: 0.8; }
.qt-cachtai { margin-top: 1rem; }
.qt-canh-bao { color: #b45309; }
.qt-luuy { color: #b45309; }
.qt-ly-do { font-size: 0.8rem; color: #b45309; text-align: right; }
.qt-ketqua ul { margin: 0.4rem 0 0 1.1rem; list-style: disc; }
</style>
